var submitContactForm = function(response) {
	var contactUtil = Fw.component.models().contactUtil;
    // console.log("captcha");
	contactUtil.submitContactForm(response);
};

/*var onloadCallback = function() {
	grecaptcha.render('submit', {
		'sitekey' : '6LcWbhsUAAAAACVIn_S_LHCQlN3HsU_TlyILZcVu',
		'callback' : submitContactForm
	});
};*/